import { render, staticRenderFns } from "./PaginationInfo.vue?vue&type=template&id=eac01a32&"
import script from "./PaginationInfo.vue?vue&type=script&lang=js&"
export * from "./PaginationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports